/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Case_Chat_Imported_AtInputs */

const en_case_chat_imported_at = /** @type {(inputs: Case_Chat_Imported_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Added on ${i?.date}`)
};

const pt_br2_case_chat_imported_at = /** @type {(inputs: Case_Chat_Imported_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionado em ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Added on {date}" |
*
* @param {Case_Chat_Imported_AtInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_chat_imported_at = /** @type {((inputs: Case_Chat_Imported_AtInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Chat_Imported_AtInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_chat_imported_at(inputs)
	return pt_br2_case_chat_imported_at(inputs)
});